// extracted by css-extract-rspack-plugin
export default {"highlight":"q_nGI","block":"qrrRP","inline":"XKlJJ"};